module.exports = __webpack_public_path__ + "static/media/logo1.335f42d9.svg";